<template>
  <div class="pinnacle-map-container d-flex align-items-center justify-content-center">
    <b-spinner v-if="!pinnacleServiceAccessGranted"></b-spinner>
    <div v-else id="pinanacleMapContainer"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
import axios from "axios";

export default {
  name: "PinnacleMap",
  props: {
    center: {
      type: Object,
      required: true,
    },
    zoom: {
      type: Number,
      required: true,
    },
    primaryRecipientId: {
      type: String,
      required: true,
    },
    geography: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentUsers: [],
      pinnacleUUID: null,
      pinnacleMap: null,
      pinnacleMapView: null,
      pinnacleInterface: null,
      pinnacleServiceAccessGranted: false,
    };
  },
  computed: {
    ...mapGetters("user", ["currentSession", "currentUser"]),
    isPinnacleInterfaceReady() {
      return this.pinnacleInterface && this.pinnacleInterface.isLoaded;
    }
  },
  created() {
    this.pinnacleUUID = this.primaryRecipientId;
    this.bootstrap();

    EventBus.$on("updatePinnacleMapLocation", this.updatePinnacleMapLocation);
  },
  methods: {
    updatePinnacleMapLocation(data) {
      if (this.isPinnacleInterfaceReady) {
        if (this.currentUsers.includes(data.id)) {
          this.updateUserLocation(data);
        } else {
          this.addUserToMapInterface(data);
        }
      }
    },
    checkPinnacleMapServiceAccess() {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": process.env.VUE_APP_NEXTNAV_APIKEY,
        "nn-headers": JSON.stringify({ "nn-timestamp": Date.now(), "nn-app-name": "3dsdkapp" })
      };

      const payload = {
        "partnerId": process.env.VUE_APP_NEXTNAV_PARTNER_ID,
        "uuid": this.pinnacleUUID,
        "sessionId": this.currentSession,
        "customerId": process.env.VUE_APP_NEXTNAV_PARTNER_ID
      };

      return axios.post(process.env.VUE_APP_NEXTNAV_AUTH_API, payload, { headers });
    },
    async bootstrap() {
      this.pinnacleMap = window.PinnacleMap;
      this.pinnacleServiceAccessGranted = false;
      await this.checkPinnacleMapServiceAccess().then(res => {
        this.pinnacleServiceAccessGranted = true;
        this.pinnacleInterface = this.pinnacleMap.getInstance({
          apiKey: process.env.VUE_APP_NEXTNAV_APIKEY,
          UUID: this.pinnacleUUID,
          partnerID: process.env.VUE_APP_NEXTNAV_PARTNER_ID,
          customerID: process.env.VUE_APP_NEXTNAV_PARTNER_ID,
        });
      }).catch(err => {
        console.log(err);
        this.pinnacleServiceAccessGranted = false;
      });

      if (this.pinnacleServiceAccessGranted) {
        if (this.pinnacleInterface && !this.pinnacleInterface.isLoaded) {
          this.pinnacleInterface.on("load", () => {
            this.initializeMap();
          });
        } else if (this.pinnacleInterface && this.pinnacleInterface.isLoaded) {
          this.initializeMap();
        }
      }
    },
    initializeMap() {
      const { Map } = this.pinnacleMap;
      this.pinnacleMapView = new Map('pinanacleMapContainer', {
        zoom: this.zoom,
        center: [this.center.lng, this.center.lat],
      });

      this.pinnacleMapView.on("load", () => {
      });
    },
    addUserToMapInterface(user) {
      if (this.isPinnacleInterfaceReady) {
        if (!this.currentUsers.includes(user.id)) {
          const { UserData, UserType } = this.pinnacleMap;
          this.pinnacleInterface.addUser(new UserData({
            id: `${user.id}`,
            userType: UserType.E911USER,
            imgPath: this.primaryRecipientId != user.recipient_id ? '../images/security.png' : '../images/e911caller.png',
            lat: user.lat,
            lng: user.lng,
            hat: user.hat,
            efl: user.efl,
            firstName: `${user.id}`,
            lastName: `${user.id}`,
          }));
          this.currentUsers.push(`${user.id}`);
        }
      }
    },
    updateUserLocation(data) {
      if (this.isPinnacleInterfaceReady) {
        const { id, lat, lng, hat, efl } = data;
        this.pinnacleInterface.updateUserLocation({ id, lat, lng, hat, efl });
      }
    },
  },
  watch: {
    isPinnacleInterfaceReady(ready) {
      if (ready) {
        this.pinnacleInterface.setMapLocation({
          lat: this.center.lat,
          lng: this.center.lng,
          zoom: this.zoom,
        });

        if (this.geography && this.geography.length > 0) {
          this.geography.forEach(geo => {
            this.addUserToMapInterface(geo);
          });
        }
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("updatePinnacleMapLocation", this.updatePinnacleMapLocation);
    this.pinnacleServiceAccessGranted = false;
    if (this.currentUsers.length > 0) {
      this.currentUsers.forEach(user => {
        this.pinnacleInterface.removeUser(`${user.id}`);
      });
      this.currentUsers = [];
    }

    this.pinnacleMapView = null;
    this.pinnacleInterface = null;
    this.pinnacleMap = null;

    const currentUserId = this.currentUser.user_id;
    const sdkElementId = `pinnacle-sdk-user-${currentUserId}`;
    const findSdkElement = document.getElementById(sdkElementId);
    if (findSdkElement) {
      document.head.removeChild(findSdkElement);
      this.$store.commit("pinnacle/setPinnacleSDKLoadedStatus", false);
    }
  }
};
</script>

<style lang="scss">
.pinnacle-map-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  > div.mapboxgl-map {
    height: 100% !important;

    .mapboxgl-canvas-container {
      width: 100% !important;
      height: 100% !important;

      canvas {
        width: 100% !important;
        height: 100% !important;
      }
    }

    .helptool.hidden {
      opacity: 0 !important;
    }

    #mainDiv {
      position: absolute !important;
    }

    .logo {
      top: 0;
      left: 0;
    }

    .map-controls {
      width: 56px !important;
      div.mapboxgl-ctrl.mapboxgl-ctrl-group {
        width: 44px !important;
        left: 6px !important;
        padding: 0 !important;
        top: 10px !important;

        > button {
          margin-left: 7px !important;
        }
      }

      div.btn_icon {
        width: 44px !important;
        height: 44px !important;
        padding: 0 !important;
        left: 6px !important;
      }
    }
    .menuContainer {
      div.btn_icon {
        width: 40px !important;
        height: 40px !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
